/**
 * Auth compatibility seam.
 *
 * Authentication state is intentionally tab-local. A profile-wide
 * BroadcastChannel cannot confidentially carry a bearer, refresh token, user
 * record, or session binding: every same-origin tab receives the wire payload
 * before application code can filter it. Each tab therefore performs its own
 * server/IdP bootstrap and refresh, and logout affects only that tab.
 *
 * The exported no-op methods keep the auth capture/bridge call sites simple
 * without creating a covert cross-tenant credential channel.
 */
import { hasAccessToken } from "./authTokenStore.js";

export function startAuthBroadcast() {}

export function broadcastTokens(payload) {
    void payload;
}

export function broadcastClear(binding) {
    void binding;
}

export async function requestSiblingTokens() {
    return hasAccessToken();
}

export function _resetForTests() {}
